<template>
  <div class="micro-elements">
    <container>
      <template v-slot:header>
        {{$ml.get(`NUTRIENT CONTENT, %`)}}
      </template>
      <div class="content">
        <before v-if="Object.keys(data.before).length > 0" :data="data.before"/>
        <after v-if="Object.keys(data.after).length > 0" :data="data.after"/>
      </div>
    </container>
  </div>
</template>

<script>
import Container from "@/components/common/HeadedContainer"
import Before from "./Before"
import After from "./After"

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Container,
    Before,
    After
  },
  created () {
    // console.log(this.data);
  }
}
</script>

<style lang="scss" scoped>
  .micro-elements {
    .content {
      width: 100%;
      display: flex;
      padding: 25px 35px;
      box-sizing: border-box;
      flex-direction: column;
    }
  }
</style>
